import React, { useEffect, useState } from 'react'
import BreadCrumbBar from '../../common/breadCrumbBar/BreadCrumbBar'
import '../../css/common.css'
import { DataGrid } from '@mui/x-data-grid';
import SearchBar from '../../common/searchBar/SearchBar';
import ExportExcel from '../../common/excel/ExportExcel';
import moment from 'moment/moment';
import { ApiService } from '../../services/apiService';
import { useSelector } from 'react-redux';
import Warning from '../../common/alert/Warning';
import { CircularProgress } from '@mui/material';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import { dateFormat, isBase64Encoded } from '../../common';
import Delete from '../../common/alert/Delete';

export default function DeviceList() {
	const [rowData, setRowData] = useState([]);
	let params = "";
	const [containData, setContainData] = useState({});
	const [rowCount, setRowCount] = useState(0);
	const [excelClick, setExcelClick] = useState(false);
	const [excelList, setExcelList] = useState([]);
	const [totalLength, setTotalLength] = useState(0);
	const [loading, setLoading] = useState(false);
	const authData = useSelector(state => state.auth);
	const role = authData.user.role.includes("devices");
	const [openWarning, setOpenWarning] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [alertOpen, setAlertOpen] = useState(false);
	const [clickItem, setClickItem] = useState('');
	const [paginationModel, setPaginationModel] = useState({
		page: 0,
		pageSize: 30,
	});

	const closeWarning = (data) => {
		setOpenWarning(data);
	}

	const xlsxHeader = {
		header: [
			'단말아이디', '단말명', '모델명', '기기상태', 'F/W 버전', '등록일자', '통신수단'
		]
	}

	const today = moment().format('YYYY-MM-DD');
	
	const xlsxFileName = "단말정보리스트_" + today;

	const getExcelData = async () => {
		setExcelClick(false);
    setLoading(true);
    params = `limit=${totalLength}`;

		try {
			const response = await ApiService.getDeviceList(params);
			const excelRows = response.data.datas.map((data) => {
        const result = isBase64Encoded(data.id);
        if (result) {
          data.id = window.atob(data.id);
        }

        if (data.state === 0) {
          data.state = "OFF";
        } else if (data.state === 1) {
          data.state = "ON";
        } else {
          data.state = "undefined";
        }

        if (data.comm === 1) {
          data.comm = "WIFI";
        } else if (data.comm === 2) {
          data.comm = "BT";
        } else {
          data.comm = "undefined";
        }

        data.created = dateFormat(new Date(data.created));
        return {
          단말아이디: data.id,
          단말명: data.name,
          모델명: data.model,
          기기상태: data.state,
          "F/W버전": data.fwver,
          등록일자: data.created,
          통신수단: data.comm,
        };
      });
			setExcelClick(true);
      setExcelList(excelRows);
		} catch(error) {
			console.log("DeviceList - getExcelData - error :: ", error);
		} finally {
			setLoading(false);
		}
  };

	const getDeviceList = async (limit, page, containData, startTime, endTime) => {
		if(startTime !== null && endTime !== null) {
			params = `limit=${limit}&offset=${limit*page}&stime=${startTime}&etime=${endTime}`;
		} else {
			params = `limit=${limit}&offset=${limit*page}&contains=${JSON.stringify(containData)}`;
		}

		try {
			setLoading(true);
			const deviceList = await ApiService.getDeviceList(params);
			//엑셀 출력 시 전체 리스트를 조회해야하기 때문에
			if(JSON.stringify(containData) === '{}' && (startTime === null && endTime === null)) {
				setTotalLength(deviceList.data.total);
			}
			const rows = deviceList.data.datas.map((data) => {
				const result = isBase64Encoded(data.id);
				if(result) {
					data.id = window.atob(data.id);
				} 

				if (data.state === 0) {
					data.state = "OFF";
				} else if (data.state === 1) {
					data.state = "ON";
				} else {
					data.state = "undefined";
				}

				if(data.comm === 1) {
					data.comm = "WIFI";
				} else if (data.comm === 2) {
					data.comm = "BT";
				} else {
					data.comm = "undefined";
				}

				data.created = dateFormat(new Date(data.created))
				return data;
			})

			setRowData(rows);
			setRowCount(deviceList.data.total);
		} catch(error) {
			console.log('DeviceList - getDeviceList - error :: ', error);
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		//등록일자 검색할 경우
		if(containData["created"]) {
			let startTime = Math.floor(new Date(containData["created"] + " 00:00:00") / 1000);
			let endTime = Math.floor(new Date(containData["created"] + " 23:59:59") / 1000);
			getDeviceList(paginationModel.pageSize, paginationModel.page, containData, startTime, endTime);
		} else {
			getDeviceList(paginationModel.pageSize, paginationModel.page, containData, null, null);
		}
	}, [paginationModel.page, containData])

	const alertOpenHandle = (id) => {
		setAlertOpen(true);
		setClickItem(id);
	}

	const alertCloseHandle = () => {
		setAlertOpen(false);
		setClickItem('');
	}

	const handleDelete = async () => {
		try {
			await ApiService.deleteDevice(clickItem);
			// alertCloseHandle();
		} catch (error) {
			console.log('DeviceList - handleDelete - error :: ', error)
			setOpenWarning(true);
			setErrorMsg(error.response.data.message);
		} finally {
			alertCloseHandle();
			getDeviceList(paginationModel.pageSize, paginationModel.page, containData, null, null);
		}
	}

	const columns = [
		{
			field: 'id',
			headerName: '단말아이디',
			minWidth: 220, 
			flex: 2, 
		},
		{
			field: 'name',
			headerName: '단말명',
			minWidth: 180, 
			flex: 1, 
		},
		{
			field: 'model',
			headerName: '모델명',
			minWidth: 180, 
			flex: 1, 
		},
		{
			field: 'state',
			headerName: '기기상태',
			minWidth: 110, 
			flex: 0.5, 
		},
		{
			field: 'fwver',
			headerName: 'F/W 버전',
			minWidth: 110, 
			flex: 0.5,
		},
		{
			field: 'created',
			headerName: '등록일자',
			minWidth: 160, 
			flex: 1, 
		},
		{
			field: 'comm',
			headerName: '통신수단',
			minWidth: 110, 
			flex: 0.5, 
		},
		{
			field: 'delete',
			headerName: '삭제',
			flex: 0.5,
			minWidth: 100,
			renderCell: (params) => {
				return(
					<>
						<button className="deleteBtn" onClick={() => alertOpenHandle(window.btoa(params.row.id))}><RemoveCircleRoundedIcon sx={{pr:1, verticalAlign: "-1px", fontSize: "15px"}}/>삭제</button>
					</>
				)
			}
		},
	];

	const options = [
		{ 
			value: 'none',
			item: '검색할 항목 선택',
		},
		{ 
			value: 'id',
			item: '단말아이디',
		},
		{ 
			value: 'created',
			item: '단말 등록일자',
		},
	];

	const getData = (selectValue, inputValue) => {
		if ((selectValue === "none") && (inputValue !== "")) {
			setOpenWarning(true);
			setErrorMsg('검색할 항목을 선택하세요!');
		} else {
			if (inputValue === "") {
				setContainData({})
			} else {
				if (selectValue === "state") {
					if ((inputValue.toLowerCase()).trim() === "off") {
						inputValue = 0;
					} else {
						inputValue = 1;
					}
				}

				if (selectValue === "comm") {
					if ((inputValue.toLowerCase()).trim() === "wifi") {
						inputValue = 1;
					} else {
						inputValue = 2;
					}
				}

				if ((selectValue === "state") || (selectValue === "comm")) {
					setContainData({ [selectValue]:  inputValue })
				} else if (selectValue === "id") {
					setContainData({ [selectValue]: window.btoa(inputValue.trim()) });
        } else {
          setContainData({ [selectValue]: inputValue.trim() });
        }
			}
		} 
	}

	return (
    <div className="containList">
      {role !== true ? (
        <Warning
          open={openWarning}
          onHideWarning={closeWarning}
          warningMsg={"해당 메뉴에 대한 권한이 없습니다!"}
        ></Warning>
      ) : (
        <>
          <BreadCrumbBar menu="단말 관리" smenu="단말 조회" />
          <div className="containItem">
            <div className="excelBtn" onClick={getExcelData}>
              <ExportExcel
                excelClick={excelClick}
                header={xlsxHeader}
                excelData={excelList}
                fileName={xlsxFileName}
              />
            </div>
            <SearchBar options={options} getData={getData} />
          </div>

          <div className="gridItem">
            {loading && (
              <CircularProgress
                sx={{ position: "absolute", top: "50%", left: "50%" }}
              />
            )}
            <DataGrid
              sx={{
                ".MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                },
              }}
              rows={rowData}
              columns={columns}
              columnHeaderHeight={35}
              rowHeight={23}
              autoHeight={true}
              paginationMode="server"
              pageSizeOptions={[paginationModel.pageSize]}
              rowCount={rowCount}
              onPaginationModelChange={setPaginationModel}
              paginationModel={paginationModel}
              disableColumnMenu={true}
              disableSelectionOnClick
            />
          </div>
        </>
      )}

      <Warning
        open={openWarning}
        onHideWarning={closeWarning}
        warningMsg={errorMsg}
      ></Warning>

      <Delete
        openDelete={alertOpen}
        closeDelete={alertCloseHandle}
        onClickDelete={handleDelete}
      />
    </div>
  );
}
